<template>
    <div v-if="!isLoading" class="view-login" :style="loginStyle">
        <page-header
            :headroom-disabled="true"
        ></page-header>

        <div class="login">
            <div class="login__form content-dimensioning form-dimensioning">

                <base-section :section="getSection">
                    <form slot="component" accept-charset="UTF-8" @submit.prevent="login" ref="form">

                        <input-element
                            v-if="useCredentials"
                            :placeholder="t('username')"
                            name="loginName"
                            id="loginName"
                            v-model="loginName" />

                        <input-element
                            :placeholder="t('password')"
                            name="password"
                            id="password"
                            type="password"
                            v-model="password" />

                        <div class="errors" v-if="error">
                            <span class="error">{{ error }}</span>
                        </div>

                        <div class="buttons">
                            <button-element
                                @click="handleSubmitButtonClick"
                                :button="{
                                    'label': t('login'),
                                }"
                                :disabled="isLoggingIn"
                            >
                                <span slot="icon" v-if="isLoggingIn">
                                    <loader-element />
                                </span>
                            </button-element>
                        </div>
                    </form>
                </base-section>
            </div>
        </div>
        <page-footer></page-footer>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import {
    UITEXTS_FETCH_NS,
    AUTHENTICATION_LOGIN_NS,
    PAGE_FETCH_NS,
} from "@/store/actions.type";

import PageHeader from '@/components/common/PageHeader.vue';
import PageFooter from '@/components/common/PageFooter.vue';
import InputElement from '@/components/elements/form/InputElement.vue';
import ButtonElement from '@/components/elements/ButtonElement.vue';
import LoaderElement from '@/components/elements/LoaderElement.vue';
import BaseSection from '@/components/sections/BaseSection.vue';

export default {
    name: 'LoginView',
    components: {
        PageHeader,
        PageFooter,
        BaseSection,
        InputElement,
        ButtonElement,
        LoaderElement,
    },
    data() {
        return {
            loginName: '',
            password: '',
            useCredentials: true,
            error: ''
        }
    },
    computed: {

        ...mapGetters('header', {
            getHeaderHeight: 'getHeight',
        }),

        ...mapGetters('uitexts', {
            t: 't',
        }),
        ...mapGetters('authentication', {
            isLoggingIn: 'isLoading',
            isLoggedIn: 'isLoggedIn',
        }),

        getSection() {
            return {
                "type": "section-text-only",
                "introtext": {
                    "headline": null,
                    "subline": null,
                    "copytext": null,
                    "button": null
                },
                "media": null,
                "component": null,
                "settings": {
                    "section": {
                        "foreground": "dark",
                        "backgroundColor": "#ffffff",
                        "backgroundImage": null,
                        "textBehavior": "centered"
                    },
                    "layout": null,
                    "image": null,
                    "video": null,
                    "slideshow": null,
                    "accordion": null,
                    "abslider": null,
                    "thumbnails": null,
                    "choice": null
                }
            };
        },

        loginStyle() {

            const styles = {
                height: `calc(100vh - ${this.getHeaderHeight}px)`
            };

            return styles;
        },

        isLoading() {
            return this.isLoadingUiTexts;
        }
    },

    created() {
        document.addEventListener('keydown', this.handleKeyDown);
    },

    methods: {
        handleKeyDown(event) {
            if (event.keyCode == 13) {
                this.login();
            }
        },

        handleSubmitButtonClick() {
            this.login();
        },

        async login() {

            const { loginName, password } = this;
            this.error = '';

            let username = null;
            if (this.useCredentials) {
                username = loginName;
            }

            const loginResult = await store.dispatch(AUTHENTICATION_LOGIN_NS, {
                useCredentials: this.useCredentials,
                loginName: username,
                password,
                site: window.siteHandle,
                action: 'guestmanagement/participant-authentication/login'
            });

            await this.$nextTick();

            if (loginResult.success) {
                this.$router.push({ name: 'home' });
            } else {
                this.error = loginResult.error;
            }
        },
    },

    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }
}
</script>
